var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (zero) {
buf.push("<span class=\"number-wrap\"><span class=\"number\">" + (jade.escape(null == (jade_interp = zero) ? "" : jade_interp)) + "</span>&nbsp;</span>");}.call(this,"zero" in locals_for_with?locals_for_with.zero:typeof zero!=="undefined"?zero:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}